import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OrganizationModel } from 'src/app/organizations/models/organization.model';
import { ofActionDispatched, Actions, Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { JoinOrganizationSuccess, JoinOrganizationFail, JoinOrganization } from 'src/app/organizations/state/organizations.actions';

export interface DomainJoinDialogData {
  organization: OrganizationModel;
}

@Component({
  selector: 'app-domain-join-dialog',
  templateUrl: './domain-join-dialog.component.html',
  styleUrls: ['./domain-join-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DomainJoinDialogComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();
  organization: OrganizationModel;

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<DomainJoinDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DomainJoinDialogData,
    private actions: Actions,
    private snackBar: MatSnackBar
  ) {
    this.organization = data.organization;
  }

  ngOnInit() {
    // join organization success
    this.actions
      .pipe(
        ofActionDispatched(JoinOrganizationSuccess),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(({ organization }) => {
        this.handleJoinSuccess(organization);
      });

    // join organization failure
    this.actions
      .pipe(
        ofActionDispatched(JoinOrganizationFail),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(({ organization }) => {
        this.handleJoinFail(organization);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleCancelClick() {
   this.close(false);
  }

  handleJoinClick() {
    this.join();
  }

  handleJoinSuccess(organization: OrganizationModel) {
    this.snackBar.open(`Successfully joined "${organization.name}".`);
    this.close(true);
  }

  handleJoinFail(organization: OrganizationModel) {
    this.snackBar.open(`There was an error joining "${organization.name}".`);
  }

  join() {
    this.store.dispatch(new JoinOrganization(this.organization));
  }

  close(joined: boolean) {
    // close dialog
    this.dialogRef.close(joined);
  }
}
